// extracted by mini-css-extract-plugin
export var arrowButtonContainer = "product-family-carousel-module--arrowButtonContainer--8e3e6";
export var capacity = "product-family-carousel-module--capacity--868ef";
export var contentContainer = "product-family-carousel-module--contentContainer--e0c8a";
export var cta = "product-family-carousel-module--cta--1cdfa";
export var next = "product-family-carousel-module--next--8eca2";
export var prev = "product-family-carousel-module--prev--7c461";
export var product = "product-family-carousel-module--product--203d7";
export var productCarousel = "product-family-carousel-module--productCarousel--76987";
export var productDescription = "product-family-carousel-module--productDescription--745ed";
export var productImage = "product-family-carousel-module--productImage--342ef";
export var productImageContainer = "product-family-carousel-module--productImageContainer--dee48";
export var productName = "product-family-carousel-module--productName--8cea0";
export var specification = "product-family-carousel-module--specification--cbf7e";
export var specifications = "product-family-carousel-module--specifications--6c631";
export var subheading = "product-family-carousel-module--subheading--b4a82";
export var summary = "product-family-carousel-module--summary--acbb3";
export var title = "product-family-carousel-module--title--bfa06";
export var wrapper = "product-family-carousel-module--wrapper--b961f";